import { FormattedMessage } from 'react-intl'
import { useNavigate } from '@tanstack/react-router'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { IconButton } from '@gto/ui/icon-button'
import { ArrowLeftEndOnRectangleIcon } from '@gto/ui/icons/outline'
import { Cog6ToothIcon, UserCircleIcon, UserIcon } from '@gto/ui/icons/solid'
import { Menu } from '@gto/ui/menu'
import { Typography } from '@gto/ui/typography'

import { useAuth } from '@/hooks/use-auth'
import { zIndex } from '@/utils/constants'

export const HeaderAccountInfo = () => {
  const { user, onLogout } = useAuth()
  const isSmAndLower = useMediaQuery('down', 800)
  const navigate = useNavigate()

  if (!user || isSmAndLower) {
    return null
  }

  return (
    <Menu.Root>
      <Menu.Trigger
        render={
          <IconButton>
            <UserCircleIcon />
          </IconButton>
        }
      />
      <Menu.Portal>
        {/* Keep the menu above rbwizard's high-z navbar (zIndex.header). */}
        <Menu.Positioner
          align="end"
          style={{ zIndex: zIndex.header + 1 }}
        >
          <Menu.Popup>
            <Menu.Group>
              <div className="flex flex-row items-center gap-4 px-2 py-2.5">
                <UserCircleIcon className="size-6 text-text-primary" />
                <div className="flex flex-col items-start">
                  <Typography
                    className="mb-0 leading-[1]"
                    color="text.primary"
                    variant="subtitle1"
                  >
                    {user.first_name} {user.last_name}
                  </Typography>
                  <Typography
                    color="text.secondary"
                    variant="body3"
                  >
                    {user.email}
                  </Typography>
                </div>
              </div>
            </Menu.Group>
            <Menu.Separator />
            <Menu.Group>
              <Menu.Item
                onClick={() => {
                  navigate({ to: '/app/user/account' }).catch(console.error)
                }}
              >
                <UserIcon
                  className="size-6"
                  height={24}
                />
                <FormattedMessage id="common.controls.account" />
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  navigate({ to: '/app/user/settings' }).catch(console.error)
                }}
              >
                <Cog6ToothIcon
                  className="size-6"
                  height={24}
                />
                <FormattedMessage id="common.controls.settings" />
              </Menu.Item>
              <Menu.Item onClick={() => onLogout()}>
                <ArrowLeftEndOnRectangleIcon
                  className="size-6"
                  height={24}
                />
                <FormattedMessage id="common.controls.logout" />
              </Menu.Item>
            </Menu.Group>
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  )
}
